import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

type InlineCtaAction = Readonly<{
  label: string;
  onClick: () => void;
  id: string;
}>;

type InlineCtaCardProps = Readonly<{
  title: string;
  supportingText: string;
  primaryAction: InlineCtaAction;
  secondaryAction?: InlineCtaAction;
}>;

export const InlineCtaCard = ({
  title,
  supportingText,
  primaryAction,
  secondaryAction,
}: InlineCtaCardProps) => (
  <Box sx={cardSx}>
    <Box sx={textSx}>
      <Typography variant="text-lg-semibold">{title}</Typography>
      <Typography variant="text-sm-regular" sx={supportingTextSx}>
        {supportingText}
      </Typography>
    </Box>
    <Box sx={actionsSx}>
      {secondaryAction && (
        <Button
          id={secondaryAction.id}
          variant="contained"
          size="md"
          hierarchy="Secondary gray"
          onClick={secondaryAction.onClick}
        >
          {secondaryAction.label}
        </Button>
      )}
      <Button
        id={primaryAction.id}
        variant="contained"
        size="md"
        hierarchy="Primary"
        onClick={primaryAction.onClick}
      >
        {primaryAction.label}
      </Button>
    </Box>
  </Box>
);

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  padding: backrs.spacing['spacing-3xl'],
  width: '100%',
  backgroundColor: backrs.colors['Colors/Base/White'],
  border: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
  borderRadius: backrs.radius['radius-xl'],
});

const textSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xxs'],
});

const actionsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  gap: backrs.spacing['spacing-lg'],
});

const supportingTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
